<script lang="ts" setup>
const modelValue = defineModel<boolean | any[]>({ default: false });

const { value, disabled } = defineProps<{
  value: boolean | any;
  disabled: boolean;
  id?: string;
}>();

const emit = defineEmits(['change']);

const shouldBeChecked = computed(() => {
  if (modelValue.value instanceof Array) {
    return modelValue.value.includes(value);
  }

  return modelValue.value;
});

function updateInput(e: any) {
  let isChecked = e.target.checked;

  if (modelValue.value instanceof Array) {
    let newValue = [...modelValue.value];

    if (isChecked) {
      newValue.push(value);
    } else {
      newValue.splice(newValue.indexOf(value), 1);
    }

    emit('change', newValue);
  } else {
    emit('change', isChecked);
  }
}
</script>

<template>
  <label class="checkbox">
    <input
      :id
      v-model="modelValue"
      :checked="shouldBeChecked"
      :disabled
      :value
      class="checkbox__input hidden"
      type="checkbox"
      @change="updateInput($event)"
    />

    <span
      :class="{ 'checkbox__pseudo--disabled': disabled }"
      class="checkbox__pseudo"
    />

    <span class="checkbox__text">
      <slot />
    </span>
  </label>
</template>

<style lang="scss" scoped>
.checkbox {
  display: block;
  line-height: 16px;
  text-align: left;
  white-space: nowrap;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  &__pseudo {
    position: relative;
    display: inline-block;
    vertical-align: top;
    box-sizing: border-box;
    width: 18px;
    height: 18px;
    border: 1px solid $hell-black-80;
    border-radius: 4px;
    background-color: $white;
    transition:
      background-color ease 0.2s,
      border-color ease 0.2s;
    backface-visibility: hidden;

    &--disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    &:hover {
      border: 1px solid $hell-black-40;
    }

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 10px;
      height: 6px;
      margin-top: -1px;
      border-bottom: 2px solid $hell-black;
      border-left: 2px solid $hell-black;
      opacity: 0;
      transition: opacity linear 0.1s;
      transform: translate(-50%, -50%) rotate(-45deg);
    }
  }

  &__input {
    &:checked {
      ~ .checkbox__pseudo {
        border-color: $hell-black;
        background-color: $hell-black;
        transition: all ease 0.2s;

        &::after {
          border-color: $white;
          background-color: $hell-black;
          opacity: 1;
        }
      }

      &:hover {
        ~ .checkbox__pseudo {
          opacity: 0.8;
        }
      }
    }
  }

  &__text {
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 1px;
    padding-left: 8px;
    font-size: $text-sm;
    white-space: normal;
    user-select: none;
  }
}
</style>
